namespace Module {

    // --- 型定義 ---
    interface Item {
        no: string;
        title: string;
        syubetu: string;
        year: string;
        year2: string;
        region: string;
        pathuri: string;
        keyword: string;
    }


    // --- データ（実際はfetchやimportで読み込む想定。ここは直書きサンプル） ---
    const items: Item[] = [
        { no:"第1回", title:"歴史災害の見直しと災害教訓の検証", syubetu:"―", year:"―", year2:"―", region:"―", pathuri:"01bousai.pdf", keyword:",歴史災害の見直しと災害教訓の検証,れきしさいがいのみなおしとさいがいきょうくんのけんしょう,レキシサイガイノミナオシトサイガイキョウクンノケンショウ"},
        { no:"特別編", title:"津波と稲むらの火", syubetu:"津波", year:"江戸時代", year2:"1854", region:"近畿地方", pathuri:"02bousai.pdf", keyword:"津波,,,,,江戸時代,近畿地方,,和歌山県,,,,,,,,,,,,,,,,,事前防災,発生期,復旧期,防災対策工事の推進（堤防等）,迅速・適切な避難,防災意識の向上,,,,,津波と稲むらの火,つなみといなむらのひ,ツナミトイナムラノヒ"},
        { no:"第2回", title:"江戸大火と現代的教訓", syubetu:"火災", year:"江戸時代", year2:"1657", region:"関東地方", pathuri:"03bousai.pdf", keyword:"火災,,,,,江戸時代,関東地方,,東京都,,,,,本郷,小石川,麹町,,,,,,,,,,事前防災,応急期,,被災者・被災地支援の工夫,消火設備の強化,防災・避難体制の整備,迅速・適切な避難,,,,江戸大火と現代的教訓,えどたいかとげんだいてききょうくん,エドタイカトゲンダイテキキョウクン"},
        { no:"第3回", title:"長崎豪雨災害", syubetu:"豪雨", year:"昭和", year2:"1982", region:"九州地方", pathuri:"04bousai.pdf", keyword:"豪雨,風水害,,,,昭和,九州地方,,長崎県,,,,,,,,,土砂災害,洪水,,,交通途絶,ライフライン寸断,家屋浸水,,事前防災,発生期,応急期,災害研究の推進（メカニズム、予測・予報等）,防災・避難体制の整備,防災意識の向上,防災・避難体制の整備,情報提供の工夫,被災者・被災地支援の工夫,防災対策工事の推進（堤防等）,長崎豪雨災害,ながさきごううさいがい,ナガサキゴウウサイガイ"},
        { no:"第4回", title:"明治三陸地震津波", syubetu:"地震・津波", year:"明治", year2:"1896", region:"東北地方", pathuri:"05bousai.pdf", keyword:"地震,津波,,,,明治,東北地方,,青森県,岩手県,宮城県,,,三陸,,,,,,,,家屋流出,家屋浸水,,,事前防災,発生期,復旧期,迅速・適切な避難,移転・街づくりの工夫,住宅再建の工夫,被災者・被災地支援の工夫,,,,明治三陸地震津波,めいじさんりくじしんつなみ,メイジサンリクジシンツナミ"},
        { no:"第5回", title:"磐梯山噴火災害", syubetu:"火山噴火", year:"明治", year2:"1888", region:"東北地方", pathuri:"06bousai.pdf", keyword:"火山噴火,,,,,明治,東北地方,,福島県,,,,,磐梯山,,,,土砂災害,山崩れ,,,家屋埋没,,,,事前防災,発生期,復旧期,ハザードマップ・防災マップ制作,防災・避難体制の整備,地域防災計画の作成,防災対策工事の推進（堤防等）,迅速・適切な避難,被災者・被災地支援の工夫,,磐梯山噴火災害,ばんだいさんふんかさいがい,バンダイサンフンカサイガイ"},
        { no:"第6回", title:"近江・若狭地震", syubetu:"地震", year:"江戸時代", year2:"1662", region:"中部・近畿地方", pathuri:"07bousai.pdf", keyword:"地震,,,双子地震,,江戸時代,近畿地方,中部地方,福井県,滋賀県,,,,近江,若狭,,,土砂災害,液状化,,,家屋埋没,家屋浸水,,,事前防災,,,構造物機能強化（耐震化、耐火性向上等）,,,,,,,近江・若狭地震,おうみ・わかさじしん,オウミ・ワカサジシン"},
        { no:"第7回", title:"江戸地震", syubetu:"地震", year:"江戸時代", year2:"1855", region:"関東地方", pathuri:"08bousai.pdf", keyword:"地震,,,,,江戸時代,関東地方,,東京都,神奈川県,千葉県,埼玉県,,,,,,火災,,,,家屋倒壊,,,,事前防災,応急期,,被災者・被災地支援の工夫,迅速・適切な避難,,,,,,江戸地震,えどじしん,エドジシン"},
        { no:"第8回", title:"エルトゥールル号事件", syubetu:"海難事故", year:"明治", year2:"1890", region:"近畿地方", pathuri:"09bousai.pdf", keyword:"海難事故,,,,,明治,近畿地方,,和歌山県,,,,,,,,,,,,,,,,,事前防災,,,被災者・被災地支援の工夫,拠点の設置（観測所、救難所）,,,,,,エルトゥールル号事件,えるとぅーるるごうじけん,エルトゥールルゴウジケン"},
        { no:"第9回", title:"浅間山噴火", syubetu:"火山噴火", year:"江戸時代", year2:"1783", region:"関東地方", pathuri:"10bousai.pdf", keyword:"火山噴火,,,,,江戸時代,関東地方,,群馬県,,,,,,,,,火砕流,,,,家屋倒壊,土地荒廃,,,応急期,復旧期,,共助の促進,復興事業・計画の工夫,,,,,,浅間山噴火,あさまやまふんか,アサマヤマフンカ"},
        { no:"第10回", title:"濃尾(のうび)地震", syubetu:"地震", year:"明治", year2:"1891", region:"中部地方", pathuri:"11bousai.pdf", keyword:"地震,,,直下型地震,,明治,中部地方,,岐阜県,愛知県,,,,,,,,土砂災害,液状化,火災,,家屋倒壊,家屋焼失,堤防壊裂,,事前防災,応急期,,災害研究の推進（メカニズム、予測・予報等）,構造物機能強化（耐震化、耐火性向上等）,救助・救護ボランティアの支援,,,,,濃尾地震,のうびじしん,ノウビジシン"},
        { no:"第11回", title:"富士山噴火", syubetu:"火山噴火", year:"江戸時代", year2:"1707", region:"中部・関東地方", pathuri:"12bousai.pdf", keyword:"火山噴火,,,,,江戸時代,中部地方,関東地方,静岡県,山梨県,神奈川県,東京都,千葉県,,,,,降灰,土砂災害,洪水,,家屋倒壊,土地荒廃,家屋埋没,,事前防災,復旧期,,防災対策工事の推進（堤防等）,復興事業・計画の工夫,,,,,,富士山噴火,ふじさんふんか,フジサンフンカ"},
        { no:"第12回", title:"酒田大火", syubetu:"火災", year:"昭和", year2:"1976", region:"東北地方", pathuri:"13bousai.pdf", keyword:"火災,,,,,昭和,東北地方,,山形県,,,,,酒田市,,,,,,,,,,,,事前防災,発生期,,移転・街づくりの工夫,防災意識の向上,応急対応力強化,情報提供の工夫,,,,酒田大火,さかたたいか,サカタタイカ"},
        { no:"第13回", title:"関東大震災－揺れと津波による被害－", syubetu:"地震・津波", year:"大正", year2:"1923", region:"関東地方", pathuri:"14bousai.pdf", keyword:"地震,津波,,,,大正,関東地方,,東京都,神奈川県,千葉県,,,横浜,熱海,相模湾,両国,土砂災害,火災,,,家屋倒壊,家屋埋没,家屋焼失,,復旧期,発生期,事前防災,被害調査の実施,迅速・適切な避難,災害研究の推進（メカニズム、予測・予報等）,,,,,関東大震災－揺れと津波による被害－,かんとうだいしんさい－ゆれとつなみによるひがい－,カントウダイシンサイ－ユレトツナミニヨルヒガイ－"},
        { no:"第14回", title:"関東大震災－火災の実態と特徴－", syubetu:"地震・火災", year:"大正", year2:"1923", region:"関東地方", pathuri:"15bousai.pdf", keyword:"地震,津波,,,,大正,関東地方,,東京都,神奈川県,千葉県,,,横浜,熱海,相模湾,両国,土砂災害,火災,,,家屋倒壊,家屋埋没,家屋焼失,,復旧期,発生期,事前防災,被害調査の実施,迅速・適切な避難,災害研究の推進（メカニズム、予測・予報等）,,,,,関東大震災－火災の実態と特徴－,かんとうだいしんさい－かさいのじったいととくちょう－,カントウダイシンサイ－カサイノジッタイトトクチョウ－"},
        { no:"第15回", title:"十勝岳泥流災害", syubetu:"火山噴火", year:"大正", year2:"1926", region:"北海道", pathuri:"16bousai.pdf", keyword:"火山噴火,,,,,大正,北海道,,,,,,,十勝,,,,土砂災害,,,,家屋倒壊,,,,事前防災,,,防災対策工事の推進（堤防等）,拠点の設置（観測所、救難所）,ハザードマップ・防災マップ制作,防災意識の向上,,,,十勝岳泥流災害,とかちだけでいりゅうさいがい,トカチダケデイリュウサイガイ"},
        { no:"第16回", title:"雲仙普賢岳(うんぜんふげんだけ)噴火", syubetu:"火山噴火", year:"平成", year2:"1990", region:"九州地方", pathuri:"17bousai.pdf", keyword:"火山噴火,,,,,平成,九州地方,,長崎県,,,,,,,,,火砕流,土砂災害,,,家屋倒壊,交通途絶,,,事前防災,応急期,復旧期,防災対策工事の推進（堤防等）,防災・避難体制の整備,被災者・被災地支援の工夫,復興事業・計画の工夫,,,,雲仙普賢岳噴火,うんぜんふげんだけふんか,ウンゼンフゲンダケフンカ"},
        { no:"第17回", title:"東南海地震・三河地震", syubetu:"地震", year:"昭和", year2:"1944", region:"中部地方", pathuri:"18bousai.pdf", keyword:"地震,,,南海トラフ巨大地震,内陸直下型地震,昭和,中部地方,,愛知県,三重県,静岡県,岐阜県,,,,,,,,,,家屋倒壊,,,,事前防災,,,災害の記録・保存,,,,,,,東南海地震・三河地震,とうなんかいじしん・みかわじしん,トウナンカイジシン・ミカワジシン"},
        { no:"第18回", title:"善光寺(ぜんこうじ)地震", syubetu:"地震", year:"江戸時代", year2:"1847", region:"中部地方", pathuri:"19bousai.pdf", keyword:"地震,,,内陸大地震,,江戸時代,中部地方,,長野県,,,,,,,,,火災,土砂災害,洪水,,家屋倒壊,家屋埋没,田畑荒廃,,事前防災,応急期,復旧期,被災者・被災地支援の工夫,緊急工事の実施,共助の促進,災害の記録・保存,,,,善光寺地震,ぜんこうじじしん,ゼンコウジジシン"},
        { no:"第19回", title:"善光寺(ぜんこうじ)地震", syubetu:"地震", year:"江戸時代", year2:"1847", region:"中部地方", pathuri:"20bousai.pdf", keyword:"地震,,,内陸大地震,,江戸時代,中部地方,,長野県,,,,,,,,,火災,土砂災害,洪水,,家屋倒壊,家屋埋没,田畑荒廃,,事前防災,応急期,復旧期,被災者・被災地支援の工夫,緊急工事の実施,共助の促進,災害の記録・保存,,,,善光寺地震,ぜんこうじじしん,ゼンコウジジシン"},
        { no:"第20回", title:"伊勢湾台風", syubetu:"豪雨", year:"昭和", year2:"1959", region:"中部地方", pathuri:"21bousai.pdf", keyword:"台風,豪雨,風水害,,,昭和,中部地方,,愛知県,三重県,,,,楠町,,,,高潮,,,,家屋流出,,,,事前防災,発生期,,情報提供の工夫,防災意識の向上,,,,,,伊勢湾台風,いせわんたいふう,イセワンタイフウ"},
        { no:"第21回", title:"伊勢湾台風", syubetu:"豪雨", year:"昭和", year2:"1959", region:"中部地方", pathuri:"22bousai.pdf", keyword:"台風,豪雨,風水害,,,昭和,中部地方,,愛知県,三重県,,,,楠町,,,,高潮,,,,家屋流出,,,,事前防災,発生期,,情報提供の工夫,防災意識の向上,,,,,,伊勢湾台風,いせわんたいふう,イセワンタイフウ"},
        { no:"第22回", title:"関東大震災", syubetu:"地震・火災", year:"大正", year2:"1923", region:"関東地方", pathuri:"23bousai.pdf", keyword:"地震,,,,,大正,関東地方,,東京都,,,,,西神田,浅草,本所,深川,火災,,,,家屋焼失,家屋倒壊,,,応急期,復旧期,事前防災,消火設備の強化,自助・共助・公助連携,移転・街づくりの工夫,復興事業・計画の工夫,復興事業・計画の工夫,迅速な経済回復・産業復興,,関東大震災,かんとうだいしんさい,カントウダイシンサイ"},
        { no:"第23回", title:"関東大震災", syubetu:"地震・火災", year:"大正", year2:"1923", region:"関東地方", pathuri:"24bousai.pdf", keyword:"地震,,,,,大正,関東地方,,東京都,,,,,西神田,浅草,本所,深川,火災,,,,家屋焼失,家屋倒壊,,,応急期,復旧期,事前防災,消火設備の強化,自助・共助・公助連携,移転・街づくりの工夫,復興事業・計画の工夫,復興事業・計画の工夫,迅速な経済回復・産業復興,,関東大震災,かんとうだいしんさい,カントウダイシンサイ"},
        { no:"第24回", title:"飛越(ひえつ)地震", syubetu:"地震", year:"江戸時代", year2:"1858", region:"中部地方", pathuri:"25bousai.pdf", keyword:"地震,,,内陸直下型地震,,江戸時代,中部地方,,富山県,岐阜県,,,,,,,,山崩れ,土砂災害,液状化,洪水,家屋倒壊,家屋埋没,交通途絶,家屋流出,事前防災,発生期,応急期,迅速・適切な避難,被災者・被災地支援の工夫,防災対策工事の推進（堤防等）,,,,,飛越地震,ひえつじしん,ヒエツジシン"},
        { no:"第25回", title:"飛越(ひえつ)地震", syubetu:"地震", year:"江戸時代", year2:"1858", region:"中部地方", pathuri:"26bousai.pdf", keyword:"地震,,,内陸直下型地震,,江戸時代,中部地方,,富山県,岐阜県,,,,,,,,山崩れ,土砂災害,液状化,洪水,家屋倒壊,家屋埋没,交通途絶,家屋流出,事前防災,発生期,応急期,迅速・適切な避難,被災者・被災地支援の工夫,防災対策工事の推進（堤防等）,,,,,飛越地震,ひえつじしん,ヒエツジシン"},
        { no:"第26回", title:"関東大震災", syubetu:"地震", year:"大正", year2:"1923", region:"関東地方", pathuri:"27bousai.pdf", keyword:"地震,,,,,大正,関東地方,,東京都,,,,,西神田,浅草,本所,深川,火災,,,,家屋焼失,家屋倒壊,,,応急期,復旧期,事前防災,消火設備の強化,自助・共助・公助連携,移転・街づくりの工夫,復興事業・計画の工夫,復興事業・計画の工夫,迅速な経済回復・産業復興,,関東大震災,かんとうだいしんさい,カントウダイシンサイ"},
        { no:"第27回", title:"関東大震災", syubetu:"地震", year:"大正", year2:"1923", region:"関東地方", pathuri:"28bousai.pdf", keyword:"地震,,,,,大正,関東地方,,東京都,,,,,西神田,浅草,本所,深川,火災,,,,家屋焼失,家屋倒壊,,,応急期,復旧期,事前防災,消火設備の強化,自助・共助・公助連携,移転・街づくりの工夫,復興事業・計画の工夫,復興事業・計画の工夫,迅速な経済回復・産業復興,,関東大震災,かんとうだいしんさい,カントウダイシンサイ"},
        { no:"第28回", title:"チリ地震津波", syubetu:"地震・津波", year:"昭和", year2:"1960", region:"東北地方", pathuri:"29bousai.pdf", keyword:"津波,,,遠地津波,,昭和,東北地方,,宮城県,青森県,岩手県,三重県,,気仙沼,八戸,大船渡,釜石,洪水,,,,港湾機能停止,,,,発生期,事前防災,,迅速・適切な避難,災害研究の推進（メカニズム、予測・予報等）,構造物機能強化（耐震化、耐火性向上等）,防災対策工事の推進（堤防等）,移転・街づくりの工夫,,,チリ地震津波,ちりじしんつなみ,チリジシンツナミ"},
        { no:"第29回", title:"チリ地震津波", syubetu:"地震・津波", year:"昭和", year2:"1960", region:"東北地方", pathuri:"30bousai.pdf", keyword:"津波,,,遠地津波,,昭和,東北地方,,宮城県,青森県,岩手県,三重県,,気仙沼,八戸,大船渡,釜石,洪水,,,,港湾機能停止,,,,発生期,事前防災,,迅速・適切な避難,災害研究の推進（メカニズム、予測・予報等）,構造物機能強化（耐震化、耐火性向上等）,防災対策工事の推進（堤防等）,移転・街づくりの工夫,,,チリ地震津波,ちりじしんつなみ,チリジシンツナミ"},
        { no:"第30回", title:"チリ地震津波", syubetu:"地震・津波", year:"昭和", year2:"1960", region:"東北地方", pathuri:"31bousai.pdf", keyword:"津波,,,遠地津波,,昭和,東北地方,,宮城県,青森県,岩手県,三重県,,気仙沼,八戸,大船渡,釜石,洪水,,,,港湾機能停止,,,,発生期,事前防災,,迅速・適切な避難,災害研究の推進（メカニズム、予測・予報等）,構造物機能強化（耐震化、耐火性向上等）,防災対策工事の推進（堤防等）,移転・街づくりの工夫,,,チリ地震津波,ちりじしんつなみ,チリジシンツナミ"},
        { no:"第31回", title:"カスリーン台風", syubetu:"豪雨", year:"昭和", year2:"1947", region:"関東地方", pathuri:"32bousai.pdf", keyword:"台風,豪雨,風水害,,,昭和,関東地方,,群馬県,栃木県,,,,赤城山,桐生市,足利市,,土砂災害,洪水,,,家屋倒壊,家屋浸水,,,事前防災,,,防災意識の向上,,,,,,,カスリーン台風,かすりーんたいふう,カスリーンタイフウ"},
        { no:"第32回", title:"カスリーン台風", syubetu:"豪雨", year:"昭和", year2:"1947", region:"関東地方", pathuri:"33bousai.pdf", keyword:"台風,豪雨,風水害,,,昭和,関東地方,,群馬県,栃木県,,,,赤城山,桐生市,足利市,,土砂災害,洪水,,,家屋倒壊,家屋浸水,,,事前防災,,,防災意識の向上,,,,,,,カスリーン台風,かすりーんたいふう,カスリーンタイフウ"},
    ];

    const keywords: string[] = [
        "地震",
        "津波",
        "豪雨",
        "火山噴火",
        "火災",
        "海難事故",
        "構造物機能強化（耐震化、耐火性向上等）",
        "移転・街づくりの工夫",
        "防災対策工事の推進（堤防等）",
        "復興事業・計画の工夫",
        "迅速な経済回復・産業復興",
        "災害研究の推進（メカニズム、予測・予報等）",
        "ハザードマップ・防災マップ制作",
        "共助の促進",
        "防災・避難体制の整備",
        "災害の記録・保存",
        "自助・共助・公助連携",
        "情報提供の工夫",
        "迅速・適切な避難",
        "防災意識の向上",
        "暴風波浪",
        "土砂災害",
        "山崩れ",
        "液状化",
        "火砕流",
        "洪水",
        "降灰",
        "高潮",
        "拠点の設置（観測所、救難所）",
        "緊急工事の実施",
        "住宅再建の工夫",
        "消火設備の強化",
        "応急対応力強化",
        "被災者・被災地支援の工夫",
        "救助・救護ボランティアの支援",
        "被害調査の実施",
        "地域防災計画の作成"
        ];


    // 地震・津波→豪雨→火山噴火→火災→海難事故

    const syubetuSort: string[] = [
        "地震・津波",
        "地震",
        "津波",
        "地震・火災",
        "豪雨",
        "火山噴火",
        "火災",
        "海難事故",
        "―",
    ];
    const yearSort: string[] = [
        "江戸時代",
        "明治",
        "大正",
        "昭和",
        "平成",
        "―",
    ];
    const regionSort: string[] = [
        "北海道",
        "東北地方",
        "関東地方",
        "中部地方",
        "中部・関東地方",
        "中部・近畿地方",
        "近畿地方",
        "九州地方",
        "―",
    ];




// --- キーワードチェックボックスを動的生成 ---
    function buildCheckboxes(): void {
        const container = document.getElementById("searchKeywordFormItems");
        if (!container) return;

        container.innerHTML = ""; // 既存内容をクリア

        keywords.forEach((kw, i) => {
            const id = `kw_${i}`;

            const checkbox = document.createElement("input");
            checkbox.type      = "checkbox";
            checkbox.name      = `keyword${i}`;
            checkbox.id        = id;
            checkbox.className = "searchCheckbox";
            checkbox.value     = kw;

            const label = document.createElement("label");
            label.htmlFor     = id;
            label.textContent = kw;

            container.appendChild(checkbox);
            container.appendChild(label);
            container.appendChild(document.createTextNode(" "));
        });
    }


    // --- OR検索ロジック ---
    function searchByKeywords(selectedKeywords: string[]): Item[] {
        if (selectedKeywords.length === 0) return [...items];

        return items.filter(item => {
            const itemKeywords = item.keyword.split(",").map(k => k.trim());
            // OR検索: 選択済みキーワードのいずれかがアイテムに含まれるか
            return selectedKeywords.some(sk => itemKeywords.includes(sk));
        });
    }

    function searchByFreeWord(word: string): Item[] {
        const trimmed = word.trim();
        if (!trimmed) return [...items];

        // 半角・全角スペースで分割し、空文字を除去
        const words = trimmed.split(/[\s　]+/).filter(w => w.length > 0);

        return items.filter(item => {
            // OR検索: いずれかのワードがタイトル・キーワード・種別・時期・地域に含まれるか
            return words.some(w =>
                item.title.includes(w) ||
                item.keyword.includes(w) ||
                item.syubetu.includes(w) ||
                item.year.includes(w) ||
                item.region.includes(w)
            );
        });
    }

    function renderSearchLabel(type: "freeword" | "keyword", terms: string[]): void {
        const el = document.getElementById("searchKeywordList");
        if (!el) return;

        if (terms.length === 0) {
            el.textContent = "すべての情報を表示しています";
            return;
        }

        if (type === "freeword") {
            el.textContent = `フリーワード「${terms.join("」「")}」の検索結果`;
        } else {
            el.textContent = `関連キーワード「${terms.join("」「")}」の検索結果`;
        }
    }



    // --- イベント登録 ---
    function bindEvents(): void {
        // チェックボックス検索フォーム
        const keywordForm = document.getElementById("searchKeywordForm") as HTMLFormElement | null;
        if (keywordForm) {
            // チェックボックスを変更した瞬間に即時検索
            // 即時検索の場合
/*
            keywordForm.addEventListener("change", (e: Event) => {
                const target = e.target as HTMLInputElement;
                if (!target.classList.contains("searchCheckbox")) return;

                const checkboxes = keywordForm.querySelectorAll<HTMLInputElement>(".searchCheckbox:checked");
                const selected   = Array.from(checkboxes).map(cb => cb.value);

                if (selected.length === 0) {
                    const resultArea = document.getElementById("listSearchResult");
                    if (resultArea) resultArea.innerHTML = "";
                    const labelEl = document.getElementById("searchKeywordList");
                    if (labelEl) labelEl.textContent = "";
                } else {
                    const results = searchByKeywords(selected);
                    renderResults(results);
                    renderSearchLabel("keyword", selected);
                    smoothScrollTo("listSearchWord");
                }
            });
*/
            keywordForm.addEventListener("submit", (e: Event) => {
                e.preventDefault();
                const checkboxes = keywordForm.querySelectorAll<HTMLInputElement>(".searchCheckbox:checked");
                const selected   = Array.from(checkboxes).map(cb => cb.value);
                const results    = searchByKeywords(selected);


                if (selected.length === 0) {
                    const resultArea = document.getElementById("listSearchResult");
                    if (resultArea) resultArea.innerHTML = "";
                    const labelEl = document.getElementById("searchKeywordList");
                    if (labelEl) labelEl.textContent = "";
                } else {
                    const results = searchByKeywords(selected);
                    renderResults(results);
                    renderSearchLabel("keyword", selected);
                    smoothScrollTo("listSearchWord");
                }

//                renderResults(results);
//                smoothScrollTo("listSearchWord");TODO
            });
            // リセットボタン
            const btnResetKeyword = document.getElementById("btnResetKeyword") as HTMLButtonElement | null;
            if (btnResetKeyword) {
                btnResetKeyword.addEventListener("click", () => {
                    const checkboxes = keywordForm.querySelectorAll<HTMLInputElement>(".searchCheckbox");
                    checkboxes.forEach(cb => { cb.checked = false; });
                    const resultArea = document.getElementById("listSearchResult");
                    if (resultArea) resultArea.innerHTML = "";
                    const labelEl = document.getElementById("searchKeywordList");
                    if (labelEl) labelEl.textContent = "";
                });
            }
        }

        // フリーワード検索フォーム
        const inputForm = document.getElementById("searchInputForm") as HTMLFormElement | null;
        if (inputForm) {
            inputForm.addEventListener("submit", (e: Event) => {
                e.preventDefault();
                const input = inputForm.querySelector<HTMLInputElement>("#inputWord");
                const word  = input ? input.value : "";
                const words = word.trim().split(/[\s　]+/).filter(w => w.length > 0); // ← 分割して配列に
                const results = searchByFreeWord(word);
                renderResults(results);
                renderSearchLabel("freeword", words);
                smoothScrollTo("listSearchWord");

            });

            const btnReset = document.getElementById("btnResetFreeword") as HTMLButtonElement | null;
            if (btnReset) {
                btnReset.addEventListener("click", () => {
                    const input = inputForm.querySelector<HTMLInputElement>("#inputWord");
                    if (input) input.value = ""; // テキストフィールドをクリア

                    // 結果エリアをクリア
                    const resultArea = document.getElementById("listSearchResult");
                    if (resultArea) resultArea.innerHTML = "";

                    // 検索ラベルをリセット
                    const labelEl = document.getElementById("searchKeywordList");
                    if (labelEl) labelEl.textContent = "";
                });
            }

        }

        // 並び順フィルター
        const filterSyubetu = document.getElementById("filterSyubetu") as HTMLSelectElement | null;
        if (filterSyubetu) {
            filterSyubetu.addEventListener("change", () => {
                const sortKey = filterSyubetu.value;
                const sorted = [...items];

                if (sortKey === "syubetu") {
                    sorted.sort((a, b) => {
                        const ai = syubetuSort.indexOf(a.syubetu);
                        const bi = syubetuSort.indexOf(b.syubetu);
                        const aIdx = ai === -1 ? syubetuSort.length : ai;
                        const bIdx = bi === -1 ? syubetuSort.length : bi;
                        return aIdx - bIdx;
                    });
                } else if (sortKey === "year") {
                    // year2（西暦）の古い順
                    sorted.sort((a, b) => {
                        const aYear = parseInt(a.year2, 10);
                        const bYear = parseInt(b.year2, 10);
                        const aIsNaN = isNaN(aYear);
                        const bIsNaN = isNaN(bYear);
                        if (aIsNaN && bIsNaN) return 0;
                        if (aIsNaN) return 1;   // "―" は末尾へ
                        if (bIsNaN) return -1;
                        return aYear - bYear;   // 昇順（古い順）
                    });
                } else if (sortKey === "year2") {
                    // year2（西暦）の新しい順
                    sorted.sort((a, b) => {
                        const aYear = parseInt(a.year2, 10);
                        const bYear = parseInt(b.year2, 10);
                        const aIsNaN = isNaN(aYear);
                        const bIsNaN = isNaN(bYear);
                        if (aIsNaN && bIsNaN) return 0;
                        if (aIsNaN) return 1;   // "―" は末尾へ
                        if (bIsNaN) return -1;
                        return bYear - aYear;   // 降順（新しい順）
                    });
                } else if (sortKey === "region") {
                    sorted.sort((a, b) => {
                        const ai = regionSort.indexOf(a.region);
                        const bi = regionSort.indexOf(b.region);
                        const aIdx = ai === -1 ? regionSort.length : ai;
                        const bIdx = bi === -1 ? regionSort.length : bi;
                        return aIdx - bIdx;
                    });
                }
                // sortKey === "" の場合は items の元の順序のまま

                renderListItems(sorted);
            });
        }
    }


    // --- タブ切り替え ---
    function bindTabEvents(): void {
        const tabs = document.querySelectorAll<HTMLAnchorElement>('.tabHead .tab');
        const contents = document.querySelectorAll<HTMLElement>('.tabBody .tabContents');

        tabs.forEach(tab => {
            tab.addEventListener('click', (e: Event) => {
                e.preventDefault();

                const targetId = tab.getAttribute('href');

                // すべてのタブからactiveクラスを除去
                tabs.forEach(t => t.classList.remove('active'));
                // クリックされたタブにactiveクラスを付与
                tab.classList.add('active');

                // すべてのタブコンテンツからactiveクラスを除去
                contents.forEach(c => c.classList.remove('active'));
                // 対応するタブコンテンツにactiveクラスを付与
                if (targetId) {
                    const target = document.querySelector<HTMLElement>(targetId);
                    if (target) target.classList.add('active');
                }
            });
        });
    }


    // --- リスト描画の共通関数 ---
    function renderItems(targetId: string, targetItems: Item[]): void {
        const listArea = document.getElementById(targetId);
        if (!listArea) return;

        if (targetItems.length === 0) {
            listArea.innerHTML = `<div class="noResult">該当する結果がありませんでした</div>`;
            return;
        }

        listArea.innerHTML = targetItems.map(item => {
            // キーワードをカンマ分割 → 空文字除去 → <li> に変換
            const keywordList = item.keyword
                .split(",")
                .map(k => k.trim())
                .filter(k => k.length > 0)
                .map(k => `<li>${k}</li>`)
                .join("");

            return `
        <div class="item">
            <div class="detail no"><div class="detailInner">${item.no}</div></div>
            <div class="detail listtitle">
                <div class="detailInner">${item.title}</div>
                <div class="detailkeyword">${keywordList ? `<ul>${keywordList}</ul>` : ""}</div>
            </div>
            <div class="detail syubetu"><div class="detailInner">${item.syubetu}</div></div>
            <div class="detail year"><div class="detailInner">
                <div class="detailYear">
                    <div class="detailYearItem1">${item.year}</div>
                    <div class="detailYearItem2">
                        ${item.year2 && item.year2 !== "―" ? `${item.year2}年` : "―"}
                    </div>
                </div>
            </div></div>
            <div class="detail region"><div class="detailInner">${item.region}</div></div>
            <div class="detail url"><div class="detailInner"><a href="pdf/${item.pathuri}" target="_blank">詳しくみる</a></div></div>
        </div>
    `;
        }).join("");
    }


// 各呼び出し箇所を以下に変更
    function renderResults(targetItems: Item[]): void {
        renderItems("listSearchResult", targetItems);
    }

    function renderListItems(targetItems: Item[]): void {
        renderItems("listSearchItems", targetItems);
    }

    // --- スムーズスクロール ---
    function smoothScrollTo(id: string): void {
        setTimeout(() => {
            const el = document.getElementById(id);
            if (!el) return;

            const targetTop = el.getBoundingClientRect().top + window.pageYOffset;
            const startTop  = window.pageYOffset;
            const distance  = targetTop - startTop;
            const duration  = 300; // ms
            let startTime: number | null = null;

            // イージング関数（ease-in-out）
            function easeInOut(t: number): number {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            }

            function step(timestamp: number): void {
                if (startTime === null) startTime = timestamp;
                const elapsed  = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1);
                window.scrollTo(0, startTop + distance * easeInOut(progress));
                if (elapsed < duration) {
                    requestAnimationFrame(step);
                }
            }

            requestAnimationFrame(step);
        }, 0);
    }

    // MAP検索
    const mapLinks = document.querySelectorAll<HTMLAnchorElement>(".mapLink");
    mapLinks.forEach(link => {
        link.addEventListener("click", (e: Event) => {
            e.preventDefault();
            const searchWord = link.dataset.mapsearch ?? "";
            if (!searchWord) return;

            const results = items.filter(item => item.region.includes(searchWord));
            renderItems("mapSearchResult", results);

            // 結果エリアにスクロール
            smoothScrollTo("mapSearchResult");
        });
    });


    // --- matrixLinkのhrefを動的に差し替え ---
    function buildMatrixLinks(): void {
        const matrixLinks = document.querySelectorAll<HTMLAnchorElement>(".matrixLink");
        matrixLinks.forEach(link => {
            const matrixIndex = link.dataset.matrix;
            if (!matrixIndex) return;

            const index = parseInt(matrixIndex, 10) - 1; // 1始まりを0始まりに変換
            const item = items[index];
            if (!item) return;

            link.href = `pdf/${item.pathuri}`;
            link.target = "_blank";
        });
    }


            // --- 初期化 ---
    function init(): void {
        buildCheckboxes();
        bindEvents();
        bindTabEvents();
        renderListItems(items); // ← 追加
        buildMatrixLinks(); // ← 追加
    }

    // DOMContentLoaded後に実行
    document.addEventListener("DOMContentLoaded", init);





} // namespace Module
